import React, { ChangeEvent, FC } from "react";
import { useCurrencySymbol } from "hooks/useCurrencySymbol";
import CreditCardForm from "components/CreditCardForm/CreditCardForm";
import { connect } from "react-redux";
import { authCreditCardFeePercent } from "reduxFolder/selectors/globalSelectors";
import { createStructuredSelector } from "reselect";
import { BooksAddFundsFormProps } from "types/books";
import { toastResponseError } from "utils/responseMessageHelper";
import { useTranslation } from "react-i18next";
import { BooksAddFundsFormWrapper } from "../../styles/BooksAddFunds.style";
import BooksAddFundsAmountFields from "./BooksAddFundsAmountFields";

//constants for the range of funds value
const MIN_AMOUNT_ADD_FUNDS = 0.01;
const MAX_AMOUNT_ADD_FUNDS = 10000.0;

const BooksAddFundsForm: FC<BooksAddFundsFormProps> = React.memo(
  ({ formik, authCreditCardFeePercent }) => {
    const {
      values,
      errors: { amount: amountError },
      touched: touchedProp,
      setFieldValue,
    } = formik;
    const { t } = useTranslation("common");
    const currencySymbol = useCurrencySymbol();

    const handleAmountChange = (event: ChangeEvent<HTMLInputElement>) => {
      let inputValue = event.target.value.replace(/[^0-9.]/g, "");
      let numericValue = parseFloat(inputValue);
      setFieldValue("amount", inputValue);

      //range of funds value
      if (
        numericValue > MAX_AMOUNT_ADD_FUNDS ||
        numericValue < MIN_AMOUNT_ADD_FUNDS
      ) {
        toastResponseError(
          t("books.errorAmountRangeAddFunds", {
            min: MIN_AMOUNT_ADD_FUNDS,
            max: MAX_AMOUNT_ADD_FUNDS,
            currencySymbol,
          }),
          "error-range-funds",
        );
      }
    };

    return (
      <BooksAddFundsFormWrapper>
        <BooksAddFundsAmountFields
          amount={values.amount}
          amountError={amountError}
          touchedAmount={touchedProp.amount}
          onAmountChange={handleAmountChange}
          feePercent={authCreditCardFeePercent}
        />
        <CreditCardForm
          formik={formik}
          fields={{
            name: "cardDetails.name",
            number: "cardDetails.number",
            expiration: "cardDetails.expiration",
            cvv: "cardDetails.cvv",
            billing: {
              country: "address.country",
              address1: "address.address1",
              address2: "address.address2",
              city: "address.city",
              state: "address.state",
              postalCode: "address.postalCode",
            },
          }}
        />
      </BooksAddFundsFormWrapper>
    );
  },
);

const withConnect = connect(
  createStructuredSelector({
    authCreditCardFeePercent,
  }),
);

export default withConnect(BooksAddFundsForm);
